import { inject, Injector, runInInjectionContext } from '@angular/core';
import { Observable } from 'rxjs';
import { catchIfNotFound } from '../../http/utils/catch-if-not-found';
import { NavigatorService } from '../services/navigator.service';
import { Route } from '../enums/route';
import { CatchErrorReturnType } from '@web/utils';

export const catchNotFoundAndNavigateToNotFoundPage = <T, O>(
  injector: Injector,
): CatchErrorReturnType<T, O> => {
  const navigator = runInInjectionContext(injector, () =>
    inject(NavigatorService),
  );

  return catchIfNotFound(
    () =>
      new Observable((subscriber) => {
        navigator.navigateByRouterLink((provider) =>
          provider.routerLink(Route.NotFound),
        );

        subscriber.complete();
      }),
  );
};
